import { useSelector } from "react-redux";
import { addMarker } from "../../api/features/markers/actions";
import {
  getAllMarkers,
  getLabelSortedMarkers,
  getMarkers,
} from "../../api/features/markers/selectors";
import useMarkerLoad from "./useMarkerLoad";
import { useAppDispatch } from "../../api/core/useAppDispatch";

export default function useMarkers() {
  const loadStatus = useMarkerLoad();
  const markers = useSelector(getMarkers);
  const labelSortedMarkers = useSelector(getLabelSortedMarkers);
  const allMarkers = useSelector(getAllMarkers);
  const dispatch = useAppDispatch();

  function createMarker(markerData) {
    return dispatch(addMarker(markerData));
  }

  return {
    markers,
    labelSortedMarkers,
    loadStatus,
    createMarker,
    allMarkers,
  };
}
